import { render, staticRenderFns } from "./OrthoBackLoseControl.vue?vue&type=template&id=765ece53&scoped=true"
import script from "./OrthoBackLoseControl.vue?vue&type=script&lang=js"
export * from "./OrthoBackLoseControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ece53",
  null
  
)

export default component.exports